import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Person',
    field: 'personId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'personId',
      fk: 'personId',
      namespace: 'person',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Diet Option',
    field: 'dietOptionId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'dietOptionId',
      fk: 'dietOptionId',
      namespace: 'dietOption',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
